import React from 'react';
import { useTranslation } from 'react-i18next';
import ReactPlaceholder from 'react-placeholder';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Error from 'commons/src/components/errorComponents/Error';
import PageHeader from 'commons/src/components/headers/PageHeader';
import SubHeader from 'commons/src/components/headers/SubHeader';
import { mediumFormLoader } from 'commons/src/components/placeholder';
import { iaqCertificateDevices, iaqCertificateSensors } from 'commons/src/DeviceAndSensorLists';
import { paths } from '../../../constants';
import { BuildingProps } from '../../../models/commonEnums';
import { Store } from '../../../reducers';
import WellReportForm from './WellReportForm';
import styles from './WellReportPage.module.scss';

export const WellReportPageComponent = (): React.ReactElement => {
    const { t: txt } = useTranslation();
    const navigate = useNavigate();

    const locationsLoading = useSelector(
        (state: Store) => state.locations.loading && state.locations.locations.length === 0
    );
    const locationsError = useSelector((state: Store) => state.locations.error);

    const optionalBuildingProps = [BuildingProps.floors, BuildingProps.buildingYear];

    if (locationsError) {
        return <Error />;
    }

    const goBack = (): void => {
        navigate({ pathname: `/${paths.reports}` });
    };

    return (
        <div className="radon-insight-view">
            <PageHeader title={txt('WellReport.WellReport')} />
            <div className="page-wrapper-flex">
                <SubHeader onGoBack={goBack} backTitle="Reports.Reports" actionButtons={[]} />
            </div>
            <div className="page-wrapper-flex">
                <div className={styles.formContainer}>
                    <ReactPlaceholder ready={!locationsLoading} customPlaceholder={mediumFormLoader}>
                        <WellReportForm
                            acceptedDeviceTypes={iaqCertificateDevices}
                            possibleSensorTypes={iaqCertificateSensors}
                            minNumberOfDays={0}
                            maxNumberOfDays={365}
                            optionalBuildingProps={optionalBuildingProps}
                        />
                    </ReactPlaceholder>
                </div>
            </div>
        </div>
    );
};

export default WellReportPageComponent;
